import React, { FunctionComponent } from "react";
import { Badge, Skeleton, Box } from "@chakra-ui/react";
import { useIntl } from "react-intl";


interface IProps {
  state?: number;
}

const TRANSFORMER_STATE = {
  NONE: 0,
  OK: 1,
  WARNING: 2,
  OFF: 3,
  ERROR: 4,
}


const TransformerState: FunctionComponent<IProps> = ({ state }) => {
  const intl = useIntl();

  switch (state) {
    case TRANSFORMER_STATE.NONE:
      return (
        <Badge variant={"outline"} colorScheme={"gray"} title={intl.formatMessage({
            id: "transformer__state__none",
            defaultMessage: "No status",
          })}>
          <Box display="inline-block" w="2" h="3" />
        </Badge>
      )
    case TRANSFORMER_STATE.OK:
      return (
        <Badge variant="solid" colorScheme={"green"}>
          {intl.formatMessage({
            id: "transformer__state__ok",
            defaultMessage: "OK",
          })}
        </Badge>
      )
    case TRANSFORMER_STATE.WARNING:
      return (
        <Badge variant="solid" colorScheme={"yellow"}>
          {intl.formatMessage({
            id: "transformer__state__warning",
            defaultMessage: "WARNING",
          })}
        </Badge>
      )
    case TRANSFORMER_STATE.OFF:
      return (
        <Badge variant="solid" colorScheme={"gray"}>
          {intl.formatMessage({
            id: "transformer__state__off",
            defaultMessage: "OFF",
          })}
        </Badge>
      )
    case TRANSFORMER_STATE.ERROR:
      return (
        <Badge variant="solid" colorScheme={"red"}>
          {intl.formatMessage({
            id: "transformer__state__error",
            defaultMessage: "ERROR",
          })}
        </Badge>
      )
    default:
      return (
        <Skeleton minW={5} w={10} h={3} />
      )
  }
};

export default TransformerState;
